/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { atomWithStorage } from 'jotai/utils'

/**
 * Atom responsible for keeping track of the user's cookie consent preferences.
 * If the user has not yet made a choice, the value will be `undefined`.
 */
const analyticalConsentAtom = atomWithStorage<boolean | undefined>('analytical-consent', undefined, undefined, {
  getOnInit: true,
})
analyticalConsentAtom.debugLabel = 'analyticalConsentAtom'

export { analyticalConsentAtom }
